export const translations = {
  SELECT_AN_OPTION: {
    en: 'Select an option',
    sv: 'Välj ett alternativ',
    da: 'Vælg en mulighed',
    fi: 'Valitse vaihtoehto',
    no: 'Velg et alternativ',
  },
  SELECT_ALL_OPTIONS: {
    en: 'Select all options',
    sv: 'Välj alla alternativ',
    da: 'Vælg alle muligheder',
    fi: 'Valitse kaikki vaihtoehdot',
    no: 'Velg alle alternativer',
  },
  SELECT_FOUND_OPTIONS: {
    en: 'Select {number} options',
    sv: 'Välj {number} alternativ',
    da: 'Vælg {number} muligheder',
    fi: 'Valitse {number} vaihtoehtoa',
    no: 'Velg {number} alternativer',
  },
  SELECTED_OPTIONS: {
    en: 'Selected options.',
    sv: 'Valda alternativ.',
    da: 'Valgte muligheder.',
    fi: 'Valitut vaihtoehdot.',
    no: 'Valgte alternativer.',
  },
  BUTTON_OPEN: {
    en: 'Open list',
    sv: 'Öppna listan',
    da: 'Open list',
    fi: 'Open list',
    no: 'Open list',
  },
  BUTTON_CLOSE: {
    en: 'Close list',
    sv: 'Stäng listan',
    da: 'Close list',
    fi: 'Close list',
    no: 'Close list',
  },
  REMOVE: {
    en: 'Remove',
    sv: 'Ta bort',
    da: 'Remove',
    fi: 'Remove',
    no: 'Remove',
  },
  REMOVED: {
    en: 'Removed',
    sv: 'Tog bort',
    da: 'Fjernet',
    fi: 'Poistettu',
    no: 'Fjernet',
  },
  MORE_OPTION: {
    en: 'more option.',
    sv: 'alternativ till.',
    da: 'mulighed mere.',
    fi: 'vaihtoehto lisää.',
    no: 'alternativ til.',
  },
  MORE_OPTIONS: {
    en: 'more options.',
    sv: 'fler alternativ.',
    da: 'more options.',
    fi: 'more options.',
    no: 'more options.',
  },
  SEARCH: {
    en: 'Search',
    sv: 'Sök',
    da: 'Søg',
    fi: 'Hae',
    no: 'Søk',
  },
  RESULTS_FOUND: {
    en: 'options found',
    sv: 'alternativ hittades',
    da: 'muligheder fundet',
    fi: 'vaihtoehtoja löytyi',
    no: 'alternativer funnet',
  },
  NO_SEARCH_RESULTS: {
    en: 'No options found',
    sv: 'Inga alternativ hittades',
    da: 'Ingen muligheder fundet',
    fi: 'Vaihtoehtoja ei löytynyt',
    no: 'Finner ingen alternativer',
  },
  NO_OPTIONS: {
    en: 'No options available',
    sv: 'Inga alternativ tillgängliga',
    da: 'Ingen tilgængelige muligheder',
    fi: 'Ei vaihtoehtoja',
    no: 'Ingen tilgjengelige alternativer',
  },
};
